import { render, staticRenderFns } from "./plan-message.vue?vue&type=template&id=c21e6e62"
import script from "./plan-message.vue?vue&type=script&lang=js"
export * from "./plan-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports